import { LocationOption } from '../consts';
import { DateKind } from '../components/Form/Inputs/Generic/FormDatePicker/DatePicker/DateKind';
import { getStartOfDay } from '../../utils/dateUtil';
import { addDays } from 'date-fns';

export interface URLSearchParams {
  accountCode?: string;
  accountName?: string;
  locationCode?: string;
  donationType?: string;
  startDate?: string;
  endDate?: string; 
  date?: string;
  origin?: string;
  driveType?: string;
  private?: string;
  radius?: string;
}

export const parseURLParams = (searchParams: URLSearchParams) => {
  if (Object.keys(searchParams).length === 0)
    return null;
  
  const today = new Date();
  const defaultEndDate = addDays(today, 14);

  let startDate = searchParams.startDate ? new Date(`${searchParams.startDate}T00:00:00.000`) : undefined;
  let endDate = searchParams.endDate ? new Date(`${searchParams.endDate}T00:00:00.000`) : undefined;
  let dateKind = DateKind.Custom_Date;
  
  if (searchParams.date) {
    startDate = new Date(`${searchParams.date}T00:00:00.000`); 
    endDate = new Date(startDate);  
    endDate.setDate(endDate.getDate() + 1);
  }

  
  if (!startDate && !endDate) {
    startDate = today;
    endDate = defaultEndDate;
    dateKind = DateKind.Next_14_Days;
  }

  startDate = getStartOfDay(startDate);
  endDate = getStartOfDay(endDate);

  return {
    accountCode: searchParams.accountCode || '',
    accountName: searchParams.accountName || '',
    locationCode: searchParams.locationCode || '', 
    donationType: searchParams.donationType ? [searchParams.donationType] : [],
    startDate,
    endDate,
    origin: searchParams.origin || '',
    locationType: parseDriveType(searchParams.driveType),
    isPrivate: searchParams.private === 'true',
    radiusMiles: searchParams.radius,
    dateKind: dateKind
  };
};

const parseDriveType = (driveType?: string): LocationOption => {
  switch(driveType?.toLowerCase()) {
    case 'mobile':
      return LocationOption.MOBILE_DRIVE;
    case 'fixed':  
      return LocationOption.DONATION_CENTER;
    default:
      return LocationOption.ALL;
  }
};